import { createRouter, createWebHistory } from 'vue-router';

function getVueBasePath() {
  const fullPath = window.location.pathname;
  const match = fullPath.match(/(.*\/customer-portal)(\/|$)/);
  return match ? match[1] + '/' : '/';
}

const basePath = getVueBasePath();

export enum CPRouterPaths {
  homePage = '/',
  profilePage = '/profile',
  editProfilePage = '/edit-profile',
  changePasswordPage = '/change-password',
  quotesPage = '/quotes',
  singleQuotePage = '/quotes/:quoteNumber',
  shareQuotePage = '/quotes/share/:quoteHash/:quoteNumber',
  createHTCHQuotePage = '/create-htct-quote',
  companyInfoPage = '/company-info',
  createAddressPage = '/create-address',
  editAddressPage = '/edit-address',
  authPage = '/auth',
}

const customerPortalRoutes = [
  {
    path: CPRouterPaths.homePage,
    component: () => import('@/apps/website/customer-portal/views/CPHomeView.vue'),
    meta: { breadcrumb: 'Home' },
  },
  {
    path: CPRouterPaths.profilePage,
    component: () => import('@/apps/website/customer-portal/views/CPProfileView.vue'),
    meta: { breadcrumb: 'Profile' },
  },
  {
    path: CPRouterPaths.editProfilePage,
    component: () => import('@/apps/website/customer-portal/views/CPEditProfileView.vue'),
    meta: { breadcrumb: 'Edit profile', parent: CPRouterPaths.profilePage },
  },
  {
    path: CPRouterPaths.changePasswordPage,
    component: () => import('@/apps/website/customer-portal/views/CPChangePasswordView.vue'),
    meta: { breadcrumb: 'Change password', parent: CPRouterPaths.profilePage },
  },
  {
    path: CPRouterPaths.quotesPage,
    component: () => import('@/apps/website/customer-portal/views/CPQuotesView.vue'),
    meta: { breadcrumb: 'Quotes' },
  },
  {
    path: CPRouterPaths.singleQuotePage,
    component: () => import('@/apps/website/customer-portal/views/CPSingleQuoteView.vue'),
    meta: { breadcrumb: 'Quote Details', parent: CPRouterPaths.quotesPage },
  },
  {
    path: CPRouterPaths.shareQuotePage,
    component: () => import('@/apps/website/customer-portal/views/CPShareQuoteView.vue'),
    meta: { breadcrumb: 'Quote Details for Sharing', parent: CPRouterPaths.quotesPage },
  },
  {
    path: CPRouterPaths.createHTCHQuotePage,
    component: () => import('@/apps/website/customer-portal/views/CPCreateHTCHQuoteView.vue'),
    meta: { breadcrumb: 'Create HTCH quote', parent: CPRouterPaths.quotesPage },
  },
  {
    path: CPRouterPaths.companyInfoPage,
    component: () => import('@/apps/website/customer-portal/views/CPCompanyInfoView.vue'),
    meta: { breadcrumb: 'Company info' },
  },
  {
    path: CPRouterPaths.createAddressPage,
    component: () => import('@/apps/website/customer-portal/views/CPCreateAddressView.vue'),
    meta: { breadcrumb: 'Create address', parent: CPRouterPaths.companyInfoPage },
  },
  {
    path: CPRouterPaths.editAddressPage,
    component: () => import('@/apps/website/customer-portal/views/CPEditAddressView.vue'),
    meta: { breadcrumb: 'Edit address', parent: CPRouterPaths.companyInfoPage },
  },
  {
    path: CPRouterPaths.authPage,
    component: () => import('@/apps/website/customer-portal/views/CPAuthView.vue'),
    meta: { breadcrumb: 'Authentication' },
  },
];

const CustomerPortalRouter = createRouter({
  history: createWebHistory(basePath),
  routes: customerPortalRoutes,
});

export default CustomerPortalRouter;
